//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useCallback, useEffect, useRef, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNav } from 'src/onboarding/hooks/nav';
import { PaymentSystem } from '@web-solutions/react-billing/constants';

import styles from './style.module.scss';
import { t } from '@web-solutions/module-localization';
import { useUpsalePurchase } from 'core/upsale/hooks/use-upsale-purchase';
import Analytics from '@web-solutions/module-analytics';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { getLocalizedList, getLocalizedText } from 'core/utils/localized';
import Button from 'src/onboarding/components/ui/button/Button';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import { ReactComponent as LoadingIcon } from '../../assets/images/loading-white.svg';
import upsaleBundle from '../../assets/images/upsale-nutrition-bundle.png';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import instance from 'src/onboarding/api/interceptor';
import { useStore } from 'src/onboarding/store/store';
import SuccessPayment from '../webUpsale/components/successPaymentPopup';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import PaymentFailedSheet, {
  PAYMENT_FAILED_CATEGORY,
} from 'src/onboarding/components/ui/payment-failed-sheet';
import { getEnvUrl } from 'src/onboarding/helpers/getEnvUrl';
import axios from 'axios';
import upsaleEthnicity from '../../assets/images/upsale-ethnicity.png';
import { buildPwaHandoffUrl } from 'src/onboarding/helpers/pwaHandoff';
import { trackFbPurchase } from 'src/onboarding/helpers/trackFbPurchase';
import upsaleDna from '../../assets/images/upsaleDna.png';
import Cookies from 'js-cookie';
import getLocale from 'src/localization/get-locale';
import { Provider } from '@web-solutions/react-billing';
import ApplePay from 'core/payment/components/apple-pay';
import {
  selectAllProducts,
  selectPaymentProject,
  selectPaymentSystem,
} from 'core/store/billing/selectors';
import { extractDeclineCode } from 'core/payment/utils/extract-decline-code';
import { PaymentErrorState } from 'core/payment/utils/payment-error-state';
import { createOneClickPayment, handleErrorPurchase, tailoredpayOneTime } from 'core/store/billing/actions';
import Billing from '@web-solutions/module-billing';
import { setBillingBaseUrlOverride } from '@web-solutions/module-billing/api';
import { confirmStripePaymentIntent } from 'core/utils/stripe-payment';
import { applyFoodzeeAuthTokens } from 'src/onboarding/helpers/applyFoodzeeAuthTokens';

const images = {
  upsaleBundle,
  upsaleEthnicity,
  upsaleDna,
};

const UpsaleDynamic = () => {
  const { onNext } = useNav();
  const dispatch = useDispatch();
  const email = useStore((state) => state.email);
  const userId = useStore((state) => state.userId);
  const pageAnswers = useStore((state) => state.pageAnswers);
  const imageUrl = useStore((state) => state.imageUrl);
  const setPage = useStore((state) => state.setPage);
  const authTokens = useStore((state) => state.authTokens);
  const authTokensExpiry = useStore((state) => state.authTokensExpiry);
  const clearAuthTokens = useStore((state) => state.clearAuthTokens);
  const paymentMethod = useSelector((state: any) => state.billing.paymentMethod);
  const purchase = useSelector((state: any) => state.billing.purchase);
  const allProducts = useSelector(selectAllProducts);
  const paymentSystem = useSelector(selectPaymentSystem);
  const paymentProject = useSelector(selectPaymentProject);
  const isStripe = paymentSystem === PaymentSystem.STRIPE;
  const isTailoredpay = paymentSystem === PaymentSystem.TAILOREDPAY;

  const {
    upsaleDynamic,
    sendEthnicity,
    showUpsalePaymentError,
    redirectToPwa,
    //@ts-ignore
    sendFbPurchaseEvent,
  } = useRemoteConfig();
  const locale = getLocale();

  const stripeUpsaleProduct = useMemo(() => {
    if (!isStripe) return null;
    const ud: any = upsaleDynamic || {};
    const parsedAmount = parseFloat(String(ud.priceAmount).replace(/[^\d.]/g, ''));
    return {
      id: ud.stripeId || ud.productCode || ud.recurlyId || 'upsale',
      productCode: ud.productCode || ud.stripeId || ud.recurlyId || 'upsale',
      amount: parsedAmount || 0,
      currency: (purchase?.currency || 'USD').toUpperCase(),
      isOneTimePurchase: true,
    } as any;
  }, [isStripe, upsaleDynamic, purchase?.currency]);

  // TailoredPay upsell: the amount comes from the front end (as with Stripe), and
  // no payment_token is needed — the subscriber's saved card is charged, so there
  // is no card form and no 3DS.
  //
  // `product_code` is our own label for what was sold — nothing has to exist for
  // it in the TailoredPay dashboard. It comes from `upsaleDynamic.name`; the rest
  // are fallbacks so a missing `name` never sends an empty code (`recurlyId` is
  // last because it is a Recurly-specific value).
  const tailoredpayUpsaleProduct = useMemo(() => {
    if (!isTailoredpay) return null;
    const ud: any = upsaleDynamic || {};
    const parsedAmount = parseFloat(String(ud.priceAmount).replace(/[^\d.]/g, ''));

    // `name` is a plain string in the current configs, but the same key is a
    // localized object elsewhere in remote config — accept both.
    const name = typeof ud.name === 'string' ? ud.name : ud.name?.en;

    return {
      productCode:
        name || ud.product || ud.upsaleName || ud.productCode || ud.recurlyId || 'upsale',
      amount: parsedAmount || 0,
      currency: (purchase?.currency || 'USD').toUpperCase(),
    };
  }, [isTailoredpay, upsaleDynamic, purchase?.currency]);

  const upsaleProductForApplePay = useMemo(() => {
    if (
      upsaleDynamic.product &&
      typeof upsaleDynamic.product === 'object' &&
      (upsaleDynamic.product as any).currency
    ) {
      const p = upsaleDynamic.product as any;
      const parsedAmount = parseFloat(String(upsaleDynamic.priceAmount).replace(/[^\d.]/g, ''));
      return {
        ...p,
        amount: p.amount || parsedAmount || 0,
      };
    }
    const found = allProducts.find(
      (p: any) =>
        p.id === upsaleDynamic.product ||
        p.recurlyId === upsaleDynamic.recurlyId ||
        p.plan_name === upsaleDynamic.recurlyId
    );
    if (found) return found;
    const parsedAmount = parseFloat(String(upsaleDynamic.priceAmount).replace(/[^\d.]/g, ''));
    console.log('upsaleDynamic', upsaleDynamic);
    console.log('parsedAmount', parsedAmount);
    console.log('upsaleDynamic.priceAmount', upsaleDynamic.priceAmount);
    return {
      id: upsaleDynamic.recurlyId,
      amount: parsedAmount || 0,
      currency: purchase?.currency || 'usd',
    };
  }, [allProducts, upsaleDynamic, purchase]);

  const [successPayment, setSuccessPayment] = useState(false);
  const [showCheck, setShowCheck] = useState(false);
  const [failedPayment, setFailedPayment] = useState(false);
  // Raw provider error behind the failed charge. The sheet turns it into one of
  // the four states and picks the copy from it.
  const [paymentError, setPaymentError] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [currentAttempt, setCurrentAttempt] = useState(0);
  const [errorMessages, setErrorMessages] = useState([]);
  const {
    handleUpsalePurchase,
    getLastPurchaseError,
    renderPaymentProcessor,
    showPaymentPopup,
    closePaymentPopup,
  } = useUpsalePurchase();

  // True while the current attempt came from the sheet, so a success can be
  // attributed to the recovery flow instead of a first-attempt purchase.
  const isRetryAttemptRef = useRef(false);

  // QA switch, non-prod only: fails the upsale charge with the given decline
  // code without involving the provider. Needed because a test card that
  // succeeds on the paywall also succeeds here — the upsale charges the saved
  // method — so a first-charge decline can't be reproduced with test cards.
  // `:once` fails only the first purchase, leaving the retry to go through.
  const forcedFail = useMemo(() => {
    if (getEnvUrl().isProd) {
      return null;
    }

    const param = new URLSearchParams(window.location.search).get('forceUpsaleFail');

    if (!param) {
      return null;
    }

    const [rawCode, modifier] = param.split(':');

    return {
      declineCode: !rawCode || rawCode === 'true' ? 'generic_decline' : rawCode,
      once: modifier === 'once',
    };
  }, []);

  // Counts user-initiated purchases, not internal auto-retries: with `:once`
  // every attempt of the first purchase fails (so the sheet always appears) and
  // the next one — the retry from the sheet — reaches the provider.
  const purchaseRunRef = useRef(0);

  const throwForcedFailure = () => {
    if (!forcedFail || (forcedFail.once && purchaseRunRef.current > 1)) {
      return;
    }

    const error: any = new Error(`Forced upsale failure: ${forcedFail.declineCode}`);
    error.code = 'card_declined';
    error.decline_code = forcedFail.declineCode;
    throw error;
  };

  // A charge that succeeded after the sheet had already been shown is a
  // recovered sale — reported separately from a first-attempt success.
  const trackRecoveredPurchase = useCallback(() => {
    if (!isRetryAttemptRef.current) {
      return;
    }
    isRetryAttemptRef.current = false;
    Analytics.trackEvent(PAYMENT_FAILED_CATEGORY, 'success', {
      upsaleID: 'upsale-dynamic',
      place: 'upsale',
      paymentSystem,
    });
  }, [paymentSystem]);

  const { apiBaseUrl } = getEnvUrl();

  const setDnaRequestCookie = () => {
    const currentDomain = window.location.hostname;
    const domainParts = currentDomain.split('.');
    const rootDomain = domainParts.slice(-2).join('.');

    Cookies.set('dna_request', 'positive', {
      expires: 30,
      domain: `.${rootDomain}`,
      path: '/',
      secure: window.location.protocol === 'https:',
      sameSite: 'lax',
    });
  };

  const openPWAWithTokens = async (messageType = 'auth_only') => {
    if (!redirectToPwa || !authTokens) {
      return;
    }

    // Autologin: swap our accessToken for a one-time handoff code the PWA
    // redeems on start. Falls back to the plain PWA url if the swap fails.
    const pwaUrl = await buildPwaHandoffUrl(authTokens.accessToken);

    const currentDomain = window.location.hostname;
    const domainParts = currentDomain.split('.');
    const rootDomain = domainParts.slice(-2).join('.');

    const cookieData = {
      accessToken: authTokens.accessToken,
      refreshToken: authTokens.refreshToken,
      email,
      timestamp: Date.now(),
      messageType,
    };

    Cookies.set('onboarding_auth', JSON.stringify(cookieData), {
      expires: 0.5,
      domain: `.${rootDomain}`,
      path: '/',
      secure: window.location.protocol === 'https:',
      sameSite: 'lax',
    });

    window.location.href = pwaUrl;
  };

  const sendEthnicityAnswers = async () => {
    try {
      const ethnicityAnswers = Object.entries(pageAnswers).map(([key, value]) => {
        const questionText =
          //@ts-ignore
          (value.title && value.title.en) ||
          //@ts-ignore
          (typeof value.title === 'string' ? value.title : '');

        return {
          question: questionText,
          //@ts-ignore
          answer: Array.isArray(value.answer) ? value.answer.join(', ') : value.answer,
        };
      });

      const userData: any = {
        email,
      };

      if (sendEthnicity === 'onUpsale') {
        if (ethnicityAnswers.length > 0) {
          userData.ethnicity = {
            data: ethnicityAnswers,
            ...(imageUrl && { photoUrl: imageUrl }),
            appName: 'ravelo',
          };
        } else {
          userData.ethnicity = undefined;
        }
      }

      await axios.put(`${apiBaseUrl}/user/update-by-token/${userId}`, userData);
      Analytics.trackEvent('user-update-token-upsale', 'success');
    } catch (error) {
      Analytics.trackEvent('user-update-token-upsale', 'error');
      console.error('Error:', error);
    }
  };

  const sendNutritionBundleRequest = async () => {
    try {
      const payload = {
        email,
        bundle: upsaleDynamic.fileName,
        template: upsaleDynamic.letterName,
        appName: 'ravelo',
      };

      const response = await instance.post('/user/nutrition-cooking-bundle', payload);
      return response.data;
    } catch (error) {
      console.error('Error sending bundle request:', error);
    }
  };

  const sendDnaReportRequest = async () => {
    try {
      const response = await instance.post(
        '/user/dna-report',
        { appName: 'ravelo' },
        {
          headers: {
            Authorization: `Bearer ${authTokens.accessToken}`,
          },
        }
      );

      if (response.data) {
        setDnaRequestCookie();
      }
      return response.data;
    } catch (error) {
      console.error('Error sending DNA report request:', error);
    }
  };

  const sendReport = async () => {
    if (sendEthnicity === 'onUpsale' && upsaleDynamic.image !== 'upsaleDna') {
      await sendEthnicityAnswers();
    } else if (upsaleDynamic.image === 'upsaleDna') {
      await sendDnaReportRequest();
    } else {
      await sendNutritionBundleRequest();
    }
  };

  const getProductByAttempt = (attemptIndex) => {
    switch (attemptIndex) {
      case 0:
        return {
          recurlyId: upsaleDynamic.recurlyId,
          product: upsaleDynamic.product,
          name: upsaleDynamic.upsaleName,
          attempt: 1,
        };
      case 1:
        return {
          recurlyId: upsaleDynamic.alternativeProduct1?.recurlyId,
          product: upsaleDynamic.alternativeProduct1?.product,
          name: upsaleDynamic.alternativeProduct1?.upsaleName,
          attempt: 2,
        };
      case 2:
        return {
          recurlyId: upsaleDynamic.alternativeProduct2?.recurlyId,
          product: upsaleDynamic.alternativeProduct2?.product,
          name: upsaleDynamic.alternativeProduct2?.upsaleName,
          attempt: 3,
        };
      default:
        return null;
    }
  };

  const attemptPurchase = async (attemptIndex, tokenId?: string) => {
    const product = getProductByAttempt(attemptIndex);

    try {
      throwForcedFailure();
      const data = await handleUpsalePurchase({
        recurlyId: product.recurlyId,
        upsaleName: product.name,
        isNextStepBlocked: true,
        tokenId,
      });
      if (!data) {
        const errorMsg = `Payment failed for ${product.name} (attempt ${attemptIndex + 1})`;
        setErrorMessages((prev) => [...prev, errorMsg]);

        if (attemptIndex < 2 && upsaleDynamic.enableRetryMechanism) {
          const nextAttempt = attemptIndex + 1;
          setCurrentAttempt(nextAttempt);
          return await attemptPurchase(nextAttempt, tokenId);
        } else {
          throw new Error(errorMsg);
        }
      }

      Analytics.trackEvent('step', 'completed', {
        upsaleID: 'upsale-dynamic',
        result: 'upsale-dynamic_payment',
        attempt: attemptIndex + 1,
        product: product.name,
      });

      gtag('event', 'conversion', {
        send_to: 'AW-17149973324/WBLJCNvSyP0aEMym3_E_',
        value: upsaleDynamic.priceAmount,
        currency: 'USD',
        transaction_id: '',
      });

      // Reached only after the charge went through. `priceAmount` is a display
      // string like "$19.99" — the helper parses it.
      trackFbPurchase({
        enabled: sendFbPurchaseEvent,
        value: upsaleDynamic.priceAmount,
        currency: purchase?.currency,
        contentName: 'upsale-dynamic',
      });

      if (sendEthnicity === 'onUpsale' && upsaleDynamic.image !== 'upsaleDna') {
        await sendEthnicityAnswers();
      } else if (upsaleDynamic.image === 'upsaleDna') {
        await sendDnaReportRequest();
      } else {
        await sendNutritionBundleRequest();
      }

      trackRecoveredPurchase();
      setSuccessPayment(true);
      setFailedPayment(false);
      setCurrentAttempt(0);
      setTimeout(() => {
        if (redirectToPwa) {
          openPWAWithTokens('payment_success');
        }
        setSuccessPayment(false);
      }, 2000);

      return data;
    } catch (error: any) {
      const errorMsg = `Error in attempt ${attemptIndex + 1}: ${error}`;
      setErrorMessages((prev) => [...prev, errorMsg]);

      if (attemptIndex < 2 && upsaleDynamic.enableRetryMechanism) {
        const nextAttempt = attemptIndex + 1;
        setCurrentAttempt(nextAttempt);
        return await attemptPurchase(nextAttempt, tokenId);
      } else {
        throw error;
      }
    }
  };

  // Shared post-success routine for the single-call gateways (Stripe one-click and
  // TailoredPay /nmi/one-time): analytics, conversion pixel, report dispatch and
  // the success UI. Takes the payment system so the event isn't mislabelled.
  const finishOneClickPurchase = useCallback(async (usedPaymentSystem: PaymentSystem) => {
    try {
      Analytics.trackEvent('step', 'completed', {
        upsaleID: 'upsale-dynamic',
        result: 'upsale-dynamic_payment',
        paymentSystem: usedPaymentSystem,
      });

      gtag('event', 'conversion', {
        send_to: 'AW-17149973324/WBLJCNvSyP0aEMym3_E_',
        value: upsaleDynamic.priceAmount,
        currency: 'USD',
        transaction_id: '',
      });

      // The one-click path (TailoredPay / Stripe): the charge already succeeded by
      // the time this runs, so the event always matches real money.
      trackFbPurchase({
        enabled: sendFbPurchaseEvent,
        value: upsaleDynamic.priceAmount,
        currency: purchase?.currency,
        contentName: 'upsale-dynamic',
      });

      if (sendEthnicity === 'onUpsale' && upsaleDynamic.image !== 'upsaleDna') {
        await sendEthnicityAnswers();
      } else if (upsaleDynamic.image === 'upsaleDna') {
        await sendDnaReportRequest();
      } else {
        await sendNutritionBundleRequest();
      }

      trackRecoveredPurchase();
      setSuccessPayment(true);
      setFailedPayment(false);
      setTimeout(() => {
        if (redirectToPwa) {
          openPWAWithTokens('payment_success');
        }
        setSuccessPayment(false);
      }, 2000);
    } catch (e) {
      console.error('stripe upsale post-success error', e);
    }
  }, [upsaleDynamic, sendEthnicity, redirectToPwa, sendFbPurchaseEvent, purchase?.currency]);

  // TailoredPay returns HTTP 200 with `{ status: "error" }`, so a failed charge
  // must be surfaced explicitly. Unlike `handlePaymentError`, this ignores
  // `showUpsalePaymentError`: silently advancing would tell the user the bundle is
  // on its way when nothing was charged. And since the payment failed, the report
  // is NOT sent — the user gets the sheet instead.
  const showTailoredpayFailure = useCallback((error?: any) => {
    setPaymentError(error || null);
    setLoading(false);
    setFailedPayment(true);
  }, []);

  const handlePaymentError = useCallback(
    (error?: any) => {
      if (showUpsalePaymentError === false) {
        // Silent failure: still proceed as if bundle was sent
        sendReport().finally(async () => {
          if (redirectToPwa) await openPWAWithTokens('bundle_sent');
          onNext();
        });
      } else {
        // The sheet reads the state and the copy off this error.
        setPaymentError(error || null);
        setFailedPayment(true);
      }
    },
    [showUpsalePaymentError, redirectToPwa, onNext],
  );

  /**
   * Stripe counterpart of getProductByAttempt. The one-click call sends the
   * amount explicitly, so an alternative offer is only chargeable when the
   * config gives it its own price — otherwise we would bill the main offer's
   * amount for a cheaper product. Such an attempt is skipped, not guessed.
   */
  const getStripeProductByAttempt = (attemptIndex: number) => {
    const currency = stripeUpsaleProduct.currency;

    if (attemptIndex === 0) {
      return {
        id: stripeUpsaleProduct.id,
        productCode: stripeUpsaleProduct.productCode,
        amount: stripeUpsaleProduct.amount,
        currency,
        name: upsaleDynamic.upsaleName,
        description:
          upsaleDynamic.upsaleName
          || upsaleDynamic.title?.en
          || stripeUpsaleProduct.productCode,
      };
    }

    const alt =
      attemptIndex === 1 ? upsaleDynamic.alternativeProduct1 : upsaleDynamic.alternativeProduct2;

    if (!alt) {
      return null;
    }

    const amount = parseFloat(String(alt.priceAmount ?? '').replace(/[^\d.]/g, ''));

    if (!Number.isFinite(amount) || amount <= 0) {
      console.warn(
        `[upsale-dynamic] alternativeProduct${attemptIndex} has no priceAmount — skipping the Stripe retry for it`,
      );
      return null;
    }

    const id = alt.stripeId || alt.productCode || alt.recurlyId;

    if (!id) {
      console.warn(
        `[upsale-dynamic] alternativeProduct${attemptIndex} has no product id — skipping the Stripe retry for it`,
      );
      return null;
    }

    return {
      id,
      productCode: alt.productCode || id,
      amount,
      currency,
      name: alt.upsaleName,
      description: alt.upsaleName || alt.title?.en || alt.productCode || id,
    };
  };

  const handlePurchaseAndProceed = async (tokenId?: string, paymentMethodId?: string) => {
    purchaseRunRef.current += 1;

    if (isTailoredpay) {
      if (!tailoredpayUpsaleProduct) {
        // Never return silently: the user has tapped Buy, and a click that produces
        // neither a request nor a popup is indistinguishable from a dead button.

        showTailoredpayFailure();
        return;
      }

      // The token-less charge bills the card TailoredPay stored during
      // /nmi/checkout. Where the subscription was paid is NOT pre-checked here:
      // Stripe's one-click upsale doesn't either, and a wrong guess (a `purchase`
      // restored from an earlier session, or one recorded before the payment
      // system was resolved) turned the Buy button into a dead click with no
      // request at all. The backend is the authority — if there is no card on
      // file it answers "No card on file and no payment token supplied" and the
      // catch below shows the retry popup.
      if (purchase?.paymentSystem !== PaymentSystem.TAILOREDPAY) {
        console.warn(
          '[Upsale] subscription recorded as paid via',
          purchase?.paymentSystem || 'unknown',
          '— charging the TailoredPay card on file anyway',
        );
      }

      // Re-assert the Foodzee billing auth before charging. `tailoredpayOneTime`
      // validates redux `profile.apiAuth.source === 'foodzee'` and throws
      // 'Missing billing auth token' BEFORE the request, while Stripe's
      // `createOneClickPayment` sends the charge with whatever header `Billing`
      // already holds — which is why the same click works for Stripe and produces
      // no /nmi/one-time request here. That redux mirror drifts on its own (the
      // app bootstrap's `auth()` overwrites it with source 'billing'), and until
      // now only the paywall re-asserted it. Same call the paywall makes.
      if (authTokens?.accessToken) {
        applyFoodzeeAuthTokens(
          {
            accessToken: authTokens.accessToken,
            refreshToken: authTokens.refreshToken,
            uid: authTokens.userId || userId,
          },
          dispatch,
          { paymentSystem },
        );
      }

      setLoading(true);
      try {
        // No payment_token: the user is already subscribed, so the backend charges
        // the card already on file. That is why there is no card popup here.
        await dispatch(
          tailoredpayOneTime({
            amount: tailoredpayUpsaleProduct.amount,
            currency: tailoredpayUpsaleProduct.currency as any,
            productCode: tailoredpayUpsaleProduct.productCode,
            trigger: 'upsale-dynamic',
          }),
        );

        await finishOneClickPurchase(PaymentSystem.TAILOREDPAY);
      } catch (error: any) {
        dispatch(handleErrorPurchase(error, { noToast: false }));
        showTailoredpayFailure(error);
      } finally {
        setLoading(false);
      }
      return;
    }

    if (isStripe) {
      if (!stripeUpsaleProduct) {
        // Same reasoning as the TailoredPay branch above. This is also the path a
        // funnel lands on after falling back to the reserve payment system, where
        // the Stripe upsale product may well be absent — and then the Buy button
        // used to do nothing at all, with no request and nothing in the console.
        console.error('[Upsale] no Stripe upsale product built from remote config', {
          paymentSystem,
          upsaleDynamic,
        });
        showTailoredpayFailure();
        return;
      }

      // payment_system_type / payment_system_project and the Foodzee billing
      // URL live in the billing module's memory and are set only by
      // Billing.init(), which the paywall runs. After a reload straight onto
      // this page they are empty: the one-click charge went to the default
      // billing host without them and got "payment system project / type is
      // required". Restore just those values before charging — no full re-init
      // (public key, products, discounts) is needed for a one-click payment on
      // the saved method.
      if (!Billing.paymentSystemType) {
        Billing.paymentSystemType = paymentSystem;
        Billing.paymentSystemProject = paymentProject;
        setBillingBaseUrlOverride(getEnvUrl().apiBaseUrl);
      }

      // The billing auth header is module memory too and is gone after a
      // reload, so the charge came back 401. Same re-assert the TailoredPay
      // branch above does before its one-time charge.
      if (authTokens?.accessToken) {
        applyFoodzeeAuthTokens(
          {
            accessToken: authTokens.accessToken,
            refreshToken: authTokens.refreshToken,
            uid: authTokens.userId || userId,
          },
          dispatch,
          { paymentSystem },
        );
      }

      setLoading(true);
      setCurrentAttempt(0);
      setErrorMessages([]);

      // Same downsell ladder as the legacy path: the main offer first, then the
      // configured alternatives, until one charge succeeds. It used to run only
      // on the legacy provider, so on Stripe `enableRetryMechanism` did nothing.
      const maxAttempt = upsaleDynamic.enableRetryMechanism ? 2 : 0;
      let lastError: any;

      for (let attempt = 0; attempt <= maxAttempt; attempt += 1) {
        const target = getStripeProductByAttempt(attempt);

        if (!target) {
          break;
        }

        setCurrentAttempt(attempt);

        try {
          throwForcedFailure();
          const result: any = await dispatch(
            createOneClickPayment({
              amount: target.amount,
              currency: target.currency,
              productCode: target.productCode || target.id,
              productId: target.id,
              description: target.description,
              trigger: attempt === 0 ? 'upsale-dynamic' : `upsale-dynamic_${attempt}attempt`,
              // Retry with another card: charge the freshly collected method and
              // keep it on file, so any further offer in this flow uses it too.
              // Without it the backend charges the customer's saved method — the
              // one that has just been declined.
              ...(paymentMethodId
                ? { paymentMethodId, setupFutureUsage: 'off_session' as const }
                : {}),
            }),
          );

          const clientSecret = result?.client_secret || result?.clientSecret;
          let status = result?.payment_intent_status || result?.status;

          if (result?.requires_action) {
            // What the bank's confirmation window returned decides whether this
            // is a purchase. Reporting success without looking booked failed
            // payments as sales. A payment that asked for confirmation has to
            // come back `succeeded` — anything else, including nothing, fails.
            const paymentIntent = await confirmStripePaymentIntent(clientSecret);
            status = paymentIntent?.status;

            if (status !== 'succeeded') {
              throw Object.assign(new Error('Bank confirmation was not completed'), {
                code: 'payment_intent_authentication_failure',
                payment_intent_status: status,
                paymentSystem: PaymentSystem.STRIPE,
              });
            }
          } else if (status && status !== 'succeeded') {
            // A 200 with a non-succeeded intent is still a failed charge — the
            // failure details travel in the body, not as an HTTP error.
            throw Object.assign(new Error('Upsale payment was not completed'), {
              code: result?.error?.code || result?.last_payment_error?.code || status,
              decline_code:
                result?.error?.decline_code || result?.last_payment_error?.decline_code,
              payment_intent_status: status,
              paymentSystem: PaymentSystem.STRIPE,
            });
          }

          closePaymentPopup();
          await finishOneClickPurchase(PaymentSystem.STRIPE);
          setLoading(false);
          return;
        } catch (error: any) {
          lastError = error;
          setErrorMessages((prev) => [
            ...prev,
            `Stripe attempt ${attempt + 1} failed (${target.name}): ${error?.message}`,
          ]);
        }
      }

      if (upsaleDynamic.enableRetryMechanism) {
        Analytics.trackEvent('payment', 'all_attempts_failed', {
          upsaleID: 'upsale-dynamic',
          paymentSystem: PaymentSystem.STRIPE,
          retryMechanismEnabled: true,
          place: 'upsale',
          code: lastError?.code,
          decline_code: extractDeclineCode(lastError, PaymentSystem.STRIPE),
        });
      }

      dispatch(handleErrorPurchase(lastError, { noToast: true }));
      handlePaymentError(lastError);
      setLoading(false);
      return;
    }
    if (!tokenId && !purchase?.token_id) {
      showPaymentPopup();
      return;
    }

    setLoading(true);
    setCurrentAttempt(0);
    setErrorMessages([]);
    setFailedPayment(false);

    try {
      await attemptPurchase(0, tokenId);
    } catch (finalError) {
      if (showUpsalePaymentError === false) {
        await sendReport();
        if (redirectToPwa) {
          await openPWAWithTokens('bundle_sent');
        }
        onNext();
      } else {
        setFailedPayment(true);
        // The provider error carries the decline code; the wrapper thrown after
        // the last attempt doesn't.
        const providerError = getLastPurchaseError() || finalError;

        Analytics.trackEvent('payment', 'all_attempts_failed', {
          upsaleID: 'upsale-dynamic',
          errors: errorMessages,
          retryMechanismEnabled: upsaleDynamic.enableRetryMechanism,
          place: 'upsale',
          attemptCount: currentAttempt + 1,
          code: (providerError as any)?.code,
          decline_code: extractDeclineCode(providerError, paymentSystem),
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const getButtonText = () => {
    if (loading) {
      return <LoadingIcon />;
    }
    return getLocalizedText(upsaleDynamic.buttonText, locale);
  };

  /**
   * The sheet's primary button. Where it leads depends on the state:
   *  - state 3 is a glitch on the way to the bank, so it repeats the charge on
   *    the saved card straight from this screen — no window opens;
   *  - states 1 and 4 need a different card or a bank confirmation, and only the
   *    payment window can offer those. The card entered there comes back through
   *    `handleCardCollected`, so the declined method on file isn't retried. For
   *    state 4 the bank's confirmation runs inside that window too.
   * State 2 can't happen here — the user never entered a card.
   */
  const handleSheetRetry = (state: PaymentErrorState) => {
    isRetryAttemptRef.current = true;
    setFailedPayment(false);

    if (state === PaymentErrorState.TEMPORARY) {
      handlePurchaseAndProceed();
      return;
    }

    showPaymentPopup();
  };

  /**
   * A payment method was tokenized in the window — charge the offer with it.
   * Without a fresh method (a PayPal submit, say) retrying would charge the very
   * card that has just been declined, so let the window finish its own flow.
   */
  const handleCardCollected = async (formData: any) => {
    const paymentMethodId = formData?.payment_method_id;
    const tokenId = formData?.token_id;

    if (!paymentMethodId && !tokenId) {
      return;
    }

    closePaymentPopup();
    await handlePurchaseAndProceed(tokenId, paymentMethodId);
  };

  /**
   * "Skip offer": the offer is declined, so nothing is charged and nothing is
   * delivered — just move on through the flow.
   */
  const handleSkipOffer = async () => {
    setFailedPayment(false);
    isRetryAttemptRef.current = false;
    if (redirectToPwa) {
      await openPWAWithTokens('bundle_sent');
    }
    onNext();
  };

  /**
   * × or a tap on the dimming: leave the user on the offer screen so they can
   * read it again and press buy. Does NOT move them on through the flow.
   */
  const handleCloseSheet = () => {
    setFailedPayment(false);
    isRetryAttemptRef.current = false;
  };

  const handleApplePayUpsale = async (formData: any) => {
    if (formData?.token_id) {
      await handlePurchaseAndProceed(formData.token_id);
    }
  };

  const handleSkipClick = async () => {
    if (!showUpsalePaymentError) {
      await sendReport();
    }
    Analytics.trackEvent('skip', 'click');

    if (redirectToPwa && showUpsalePaymentError) {
      await openPWAWithTokens('user_skipped');
    }

    if (redirectToPwa && !showUpsalePaymentError) {
      await openPWAWithTokens('bundle_sent');
    }
    onNext();
  };

  useEffect(() => {
    if (successPayment) {
      document.body.style.overflow = 'hidden';

      const showCheckTimer = setTimeout(() => setShowCheck(true), 500);
      const nextTimer = setTimeout(() => onNext(), 1500);

      return () => {
        clearTimeout(showCheckTimer);
        clearTimeout(nextTimer);
        document.body.style.overflow = '';
      };
    } else if (failedPayment) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [successPayment, failedPayment]);

  useEffect(() => {
    if (failedPayment) {
      const timer = setTimeout(() => setLoading(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [failedPayment]);

  const formatPriceInText = (text, priceAmount) => {
    if (!text || !priceAmount) return text;

    return text.replace(/\$\d+\.\d{2}/g, `$${priceAmount}`);
  };

  const onApplePayClick = useCallback(() => {
    Analytics.trackEvent('apple_pay', 'click');
  }, []);

  return (
    <div className={styles.wrapper}>
      <main className={styles.main}>
        <div className={styles.header}>
          <h2 className={styles.headerTitle}>{getLocalizedText(upsaleDynamic.title, locale)}</h2>
          <Caption size='l' style={{ color: '#3F3F3F' }}>
            {getLocalizedText(upsaleDynamic.subTitle, locale)}
          </Caption>
          <img
            src={images[upsaleDynamic.image]}
            style={upsaleDynamic.image === 'upsaleDna' ? { transform: 'scale(1.5)' } : {}}
            className={styles.headerImg}
            alt='plans'
          />
        </div>

        <div className={styles.content}>
          {renderPaymentProcessor({
            // For Stripe the window must price the offer itself, not the paywall
            // product the funnel config points at.
            activeProduct: isStripe ? stripeUpsaleProduct : upsaleDynamic.product,
            oneTimeRecurlyId: upsaleDynamic.recurlyId,
            // Changing the payment method should offer every method the user
            // has, wallets included: inside the Apple Pay sheet they can pick a
            // different card, which is exactly what a declined charge needs.
            isOnlyCard: false,
            onCardCollected: handleCardCollected,
          })}

          <div className={styles.usersContainer}>
            <Text size='l' semibold className={styles.users}>
              {getLocalizedText(upsaleDynamic.descriptionTitle, locale)}
            </Text>
            <Text size='m' medium style={{ color: '#8A8A8A' }}>
              {getLocalizedText(upsaleDynamic.descriptionText, locale)}
            </Text>
          </div>

          <div className={styles.youGetContainer}>
            <Title tag='h4'>{t('onboarding.upsaleNutritionBundle.youGet.title')}</Title>
            <div className={styles.youGetOptions}>
              {getLocalizedList(upsaleDynamic.whatYouGetText, locale)
                ?.filter((item) => {
                  if (upsaleDynamic.movePriceToBottom) {
                    return !item.includes('Lifetime access') && !item.includes('price');
                  }
                  return true;
                })
                ?.map((item, index) => (
                  <Text key={index} size='m' medium className={styles.youGetOption}>
                    {item}
                  </Text>
                ))}
            </div>
          </div>
        </div>
        {successPayment && (
          <SuccessPayment onClose={() => setSuccessPayment(false)} showCheck={showCheck} />
        )}

        {/* TailoredPay overrides the kill-switch on purpose: it answers HTTP 200
            with `{ status: "error" }`, and advancing silently would promise a
            bundle nothing was charged for. */}
        {(showUpsalePaymentError || isTailoredpay) && (
          <PaymentFailedSheet
            visible={failedPayment}
            error={paymentError}
            paymentSystem={paymentSystem}
            method={paymentMethod}
            loading={loading}
            analyticsInfo={{ upsaleID: 'upsale-dynamic' }}
            onRetry={handleSheetRetry}
            onSkip={handleSkipOffer}
            onClose={handleCloseSheet}
          />
        )}
      </main>
      {!failedPayment && !successPayment && (
        <footer
          className={styles.footer}
          style={
            upsaleDynamic.movePriceToBottom && upsaleDynamic.bottomText ? { bottom: '16px' } : {}
          }
        >
          {/*
            TailoredPay never shows a wallet button here: the upsell is charged to
            the card already on file via /nmi/one-time — no card form, no wallet, no
            3DS. Without this the page would swap the buy button for an Apple Pay one
            just because the subscription happened to be paid that way, and render
            nothing at all (there is no app-drawn Apple Pay button for TailoredPay).
          */}
          {paymentMethod === 'applepay' && !isTailoredpay ? (
            <Provider>
              <ApplePay
                onApplePayClick={onApplePayClick}
                className={styles.appleButton}
                activeProduct={upsaleProductForApplePay}
                onApplePaySubmit={handleApplePayUpsale}
              />
            </Provider>
          ) : (
            <Button
              disabled={loading}
              title={getButtonText()}
              onClick={() => handlePurchaseAndProceed()}
            />
          )}
        </footer>
      )}
      <div
        className={styles.skip}
        style={
          upsaleDynamic.movePriceToBottom && upsaleDynamic.bottomText
            ? { bottom: '-100px' }
            : { bottom: '-60px' }
        }
      >
        {upsaleDynamic.movePriceToBottom && upsaleDynamic.bottomText && (
          <div className={styles.bottomTextContainer}>
            <p className={styles.bottomText}>
              {formatPriceInText(
                getLocalizedText(upsaleDynamic.bottomText, locale),
                upsaleDynamic.priceAmount,
              )}{' '}
              <span className={styles.privacy}>
                <a onClick={() => setPage('privacy-policy')}>
                  {t('onboarding.personalPlan.plan.privacy')}
                </a>{' '}
                and{' '}
                <a onClick={() => setPage('terms-of-use')}>
                  {t('onboarding.personalPlan.plan.terms')}
                </a>
              </span>
            </p>
          </div>
        )}
        <Button
          type='secondary'
          title={t('onboarding.upsaleNutritionBundle.skip')}
          onClick={handleSkipClick}
        />
      </div>
    </div>
  );
};

export default UpsaleDynamic;
